import React from "react";

// eslint-disable-next-line tree-shaking/no-side-effects-in-initialization
const ThemeContext = React.createContext();
const ThemeProvider = ThemeContext.Provider;
const ThemeConsumer = ThemeContext.Consumer;

const Theme = {
  dark: "theme_dark",
  light: undefined,
};

ThemeContext.displayName = "Theme.Context";

export { ThemeContext, ThemeProvider, ThemeConsumer, Theme };
